import React from 'react';

const CreateRoundIllustrationSvg = (props) => (
    <svg viewBox="0 0 120 120" {...props}>
        <defs>
            <linearGradient
                id="create-round-illustration_svg__a"
                x1={35.96}
                y1={102.11}
                x2={84.79}
                y2={17.53}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0} stopColor="#206953" stopOpacity={0.3} />
                <stop offset={1} stopColor="#206953" stopOpacity={0} />
            </linearGradient>
        </defs>
        <circle cx={60.29} cy={59.89} r={48.73} fill="#59c3a3" />
        <circle
            cx={60.38}
            cy={59.82}
            r={48.82}
            fill="url(#create-round-illustration_svg__a)"
        />
        <path
            d="M80.59 78H11.83c-1.58 0-3.26-1.78-3.75-4L8 73.58h76.4l-.08.36c-.48 2.24-2.15 4.06-3.73 4.06z"
            fill="#00acaf"
        />
        <path
            d="M18.42 20.18h55.8a1.47 1.47 0 0 1 1.47 1.47v38.77H16.95V21.65a1.47 1.47 0 0 1 1.47-1.47z"
            fill="#ccf7f6"
        />
        <path
            d="M83.11 74.64H9.43a1.43 1.43 0 0 1-1.16-2.26l8.63-12h58.74l8.63 12a1.43 1.43 0 0 1-1.16 2.26z"
            fill="#70e4e0"
        />
        <path
            d="M74.7 69.1H17.85c-.9 0-1.83-.53-1.6-.93l3-5a2.06 2.06 0 0 1 1.75-.74h50.53a2.06 2.06 0 0 1 1.82.79l3 5c.18.35-.76.88-1.65.88z"
            fill="#00acaf"
        />
        <rect
            x={20.01}
            y={23.6}
            width={52.61}
            height={33.39}
            rx={0.91}
            ry={0.91}
            fill="#70e4e0"
        />
        <path
            d="M36.63 23.6h34.29a1.71 1.71 0 0 1 1.71 1.71v30A1.71 1.71 0 0 1 70.92 57h-.86z"
            fill="#70e4e0"
        />
        <path
            fill="#ccf7f6"
            d="M57.09 74.64H35.55l3.46-5.52h14.62l3.46 5.52z"
        />
        <path fill="#ccf7f6" opacity={0.8} d="M23 27.09h46.67v29.94H23z" />
        <path
            fill="#00d8d2"
            d="M22.96 26.97h46.72v15.28H22.96zM25.67 44.54h21.2v1.67h-21.2zM25.67 48.03h14.45v1.67H25.67z"
        />
        <path
            d="M74.09 106.57l4.21-12s1.93 5.12 3.26 9.08c0 0 9.66-5.56 12.93-8.94l-3-8.49A22 22 0 0 0 98.67 79a1.28 1.28 0 0 1 1.71-.43l.15.07a1.28 1.28 0 0 0 1.77-.52 26.52 26.52 0 0 0 2.91-10.79 1.55 1.55 0 0 0-1.45-1.46 1.28 1.28 0 0 1-1.28-1.22A22.81 22.81 0 0 0 99.91 55a1.28 1.28 0 0 1 .09-1.3l.58-.35a1.28 1.28 0 0 0 .43-1.8 26.47 26.47 0 0 0-4.11-4.86 26.76 26.76 0 0 0-3.9-3.1 1.28 1.28 0 0 0-1.81.42 1.28 1.28 0 0 1-1.71.48 21.87 21.87 0 0 0-9.76-2.61c-.51 0-10.11-1.37-13.38.32a1.28 1.28 0 0 0-.55 1.8v.05a1.28 1.28 0 0 1-.42 1.71 22.34 22.34 0 0 0-7.12 7.12 1.28 1.28 0 0 1-1.72.43 1.28 1.28 0 0 0-1.78.52 26.52 26.52 0 0 0-2.88 10.8 1.26 1.26 0 0 0 .45 1 1.28 1.28 0 0 0 .94.41h.42a1.27 1.27 0 0 1 .77 1.11 21.54 21.54 0 0 0 2.61 9.74 1.28 1.28 0 0 1-.49 1.71 1.28 1.28 0 0 0-.43 1.81 27.92 27.92 0 0 0 8 8l.16.09-6.93 19.85s12.42.05 16.72-1.78z"
            fill="#282c35"
            opacity={0.1}
        />
        <path
            d="M64 81.45l13.24 4.62a.61.61 0 0 1 .38.78l-11.41 32.74a.61.61 0 0 1-1.1.11L61 112.56a.61.61 0 0 0-.75-.26l-7.58 3a.61.61 0 0 1-.8-.77l11.39-32.71a.61.61 0 0 1 .74-.37z"
            fill="#f16932"
        />
        <path
            d="M86.75 81.45l-13.23 4.62a.61.61 0 0 0-.38.78l11.44 32.74a.61.61 0 0 0 1.1.11l4.14-7.14a.61.61 0 0 1 .75-.26l7.58 3a.61.61 0 0 0 .8-.77L87.53 81.82a.61.61 0 0 0-.78-.37z"
            fill="#f16932"
        />
        <path
            d="M49 63.38a26.52 26.52 0 0 1 2.88-10.8 1.28 1.28 0 0 1 1.78-.52 1.28 1.28 0 0 0 1.72-.43 22.34 22.34 0 0 1 7.12-7.12 1.28 1.28 0 0 0 .42-1.71v-.05A1.28 1.28 0 0 1 63.4 41a26.47 26.47 0 0 1 10.83-2.9 1.28 1.28 0 0 1 1.33 1.27 1.28 1.28 0 0 0 1.22 1.27 21.87 21.87 0 0 1 9.76 2.61 1.28 1.28 0 0 0 1.71-.48 1.28 1.28 0 0 1 1.81-.42 26.79 26.79 0 0 1 7.94 7.9 1.28 1.28 0 0 1-.43 1.81 1.28 1.28 0 0 0-.5 1.7 22.81 22.81 0 0 1 2.6 9.72 1.28 1.28 0 0 0 1.28 1.22 1.28 1.28 0 0 1 1.24 1.3 26.49 26.49 0 0 1-2.9 10.83 1.28 1.28 0 0 1-1.76.53 1.28 1.28 0 0 0-1.71.43 22 22 0 0 1-7.13 7.11 1.28 1.28 0 0 0-.43 1.72 1.28 1.28 0 0 1-.52 1.77 26.49 26.49 0 0 1-10.79 2.88A1.28 1.28 0 0 1 75.58 90a1.28 1.28 0 0 0-1.22-1.28 22.19 22.19 0 0 1-9.72-2.6 1.28 1.28 0 0 0-1.69.49 1.28 1.28 0 0 1-1.81.43 26.79 26.79 0 0 1-7.9-7.89 1.28 1.28 0 0 1 .43-1.81 1.28 1.28 0 0 0 .49-1.71 21.54 21.54 0 0 1-2.61-9.74 1.28 1.28 0 0 0-1.28-1.22A1.28 1.28 0 0 1 49 63.38z"
            fill="#f58729"
        />
        <path
            d="M50.38 64.82a1.28 1.28 0 0 1-1.28-1.33 26.52 26.52 0 0 1 2.9-10.8 1.28 1.28 0 0 1 1.78-.52l22.6 12.66z"
            fill="#f9a51f"
        />
        <path
            d="M62.91 42.79a1.28 1.28 0 0 1 .5-1.79 26.52 26.52 0 0 1 10.78-2.94 1.28 1.28 0 0 1 1.34 1.27L76 65.27z"
            fill="#f9a51f"
        />
        <path
            d="M88.33 42.95a1.28 1.28 0 0 1 1.79-.45 26.52 26.52 0 0 1 8 7.84 1.28 1.28 0 0 1-.43 1.8l-22.23 13.4z"
            fill="#f9a51f"
        />
        <path
            d="M101.07 64.84a1.28 1.28 0 0 1 1.27 1.34A26.52 26.52 0 0 1 99.45 77a1.28 1.28 0 0 1-1.78.51l-22.6-12.76z"
            fill="#f9a51f"
        />
        <path
            d="M88.36 86.78a1.28 1.28 0 0 1-.52 1.77 26.52 26.52 0 0 1-10.79 2.89 1.28 1.28 0 0 1-1.34-1.28l-.31-25.92z"
            fill="#f9a51f"
        />
        <path
            d="M63 86.73a1.28 1.28 0 0 1-1.8.43 26.52 26.52 0 0 1-7.87-7.93 1.28 1.28 0 0 1 .45-1.8l22.35-13.14z"
            fill="#f9a51f"
        />
        <circle cx={75.7} cy={64.72} r={17.58} fill="#fdcd08" />
        <circle cx={75.58} cy={64.72} r={13.66} fill="#f9a51f" />
    </svg>
);

CreateRoundIllustrationSvg.displayName = 'CreateRoundIllustrationSvg';
export default CreateRoundIllustrationSvg;
